import { cn } from "@/lib/utils";

/** Bordered console overlay chrome (RTE panels, detached suggestion surfaces). */
export const CONSOLE_OVERLAY_PANEL_CLASS = cn(
  "rounded-[10px] border border-(--console-border) bg-card shadow-none",
);
